<template>
  <div class="experience-wrapper--tab-faqs">
    <el-card class="box-card experience-wrapper--section-faq" shadow="never">
      <div slot="header" class="clearfix">
        <el-form :model="form" class="form-filter" @submit.native.prevent>
          <el-form-item>
            <el-input
              v-model="form.search"
              :placeholder="$t(`${base}.placeholder.search`)"
              size="large"
              prefix-icon="el-icon-search"
            >
              <el-button slot="append" type="success">{{
                $t(`${base}.form.search`)
              }}</el-button>
            </el-input>
          </el-form-item>

          <el-form-item v-if="categories.length > 1">
            <LadTagsMultiselect
              v-model="categories"
              @change="handleSelectCategory"
            />
          </el-form-item>
        </el-form>
      </div>

      <div class="experience-wrapper--section-faq-content">
        <div class="section section-faq">
          <el-collapse v-model="activeFaqs" class="lad-el-collapse">
            <el-collapse-item
              v-for="(faq, i) in faqsList"
              :key="i"
              :name="i"
              :title="faq.question"
            >
              <template slot="title">{{ faq.question }} </template>

              <p>
                {{ faq.answer }}
              </p>

              <div class="lad-tags--list">
                <el-tag
                  v-for="category in faq.categories"
                  :key="category"
                  effect="plain"
                  :type="getTagType(category)"
                  >{{ category }}</el-tag
                >
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LadTabFaq',
  components: {
    LadTagsMultiselect: () =>
      import(
        /* webpackChunkName: "lad-tags-multiselect" */ '@/components/frontends/Tags/Multiselect'
      ),
  },
  data() {
    return {
      base: 'experience.faq',
      selectedCategories: [],
      activeFaqs: [],
      queries: [],
      form: { search: null, categories: [] },
      visaInfo: null,
      visa: { from: null /** desde */, to: undefined /** hasta */ },
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('app', ['country']),
    ...mapState('experience', {
      exFaqs: 'faqs',
      exExperience: (state) => ({
        uuid: state.experience.uuid,
        country: state.experience.country.alpha_3_code,
        permalink: state.experience.permalink.default,
        type: state.experience.type,
      }),
    }),
    faqsList() {
      let faqs = this.exFaqs || []

      if (faqs.length > 0) {
        if (this.selectedCategories.length > 0) {
          faqs = this.filterFaqsByCategories(faqs)
        }

        if (this.form.search) {
          faqs = this.filterFaqsBySearch(faqs)
        }
      }

      return faqs
    },
    tabRoute() {
      return {
        name: 'product-permalink',
        params: {
          type: this.$t(
            `router.product_permalink.type.${this.exExperience.type}`
          ),
          permalink: this.permalink,
        },
      }
    },
    enableVisa() {
      return this.exExperience.country !== this.country
    },
    categories() {
      const categories = []

      if (this.exFaqs.length > 0) {
        this.exFaqs.forEach((faq) => {
          faq.categories.forEach((category) => {
            if (!categories.includes(category)) {
              categories.push(category)
            }
          })
        })
      }

      return categories
    },
  },
  watch: {
    faqsList(newValue) {
      if (this.form.search || this.selectedCategories.length > 0) {
        if (this.form.search) {
          this.queries = this.form.search.split(' ')
        }
        this.activeFaqs = [...Array(this.faqsList.length).keys()]
      } else {
        this.queries = []
        this.activeFaqs = []
      }
    },
    'visa.from'(value) {
      this.requiredVisa()
    },
    'visa.to'(value) {
      this.requiredVisa()
    },
  },
  mounted() {
    this.$emit('mounted')

    if (this.exExperience.uuid) {
      this.requiredVisa()
    }
  },
  methods: {
    handleUpdateFromCountry(country) {
      this.visa.from = country
    },
    handleUpdateToCountry(country) {
      this.visa.to = country
    },
    handleSelectCategory(data) {
      this.selectedCategories = data
    },
    filterFaqsByCategories(faqs) {
      return faqs.filter((faq) => {
        return this.selectedCategories.some((f) => {
          return faq.categories.includes(f)
        })
      })
    },
    filterFaqsBySearch(faqs) {
      return faqs.filter((faq) => {
        const question = faq.question.removeDiacritical()
        const answer = faq.answer.removeDiacritical()
        const search = this.form.search.removeDiacritical()

        return question.includes(search) || answer.includes(search)
      })
    },
    getTagType(category) {
      return this.selectedCategories.includes(category) ? 'primary' : 'info'
    },
    async requiredVisa() {
      if (this.visa.from && this.visa.to) {
        try {
          const url = `/api/country/required-visa/${this.visa.from.alpha_3_code}/${this.visa.to.alpha_3_code}`
          const { visa, status } = await this.$axios.get(url)

          if (status === 'success') {
            this.visaInfo = visa.label
          }
        } catch (error) {}
      }
    },
  },
}
</script>

<style lang="scss">
.experience-wrapper--tab-faqs {
  .experience-wrapper--section-faq {
    .el-form-item {
      margin-bottom: 10px;
    }

    .el-card__body {
      padding: 0;
    }
  }

  .experience-wrapper--section-visa {
    .experience-wrapper--section-visa-content {
      p {
        display: table;

        & > * {
          display: table-cell;
          vertical-align: middle;
        }
      }

      i {
        font-size: 2em;
        padding-right: 10px;
      }
    }
  }

  .lad-tags--list {
    .el-tag:not(:last-of-type) {
      margin-right: 10px;
    }
  }

  .form-countries {
    grid-template-columns: 1fr 1fr;
    grid-gap: 25px;

    .el-form-item {
      margin: 0;
    }
    .el-select {
      width: 100%;
    }

    .el-form-item__content {
      display: block;
    }
  }
}
</style>
